var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureEasyApplyFilled = function SvgFeatureEasyApplyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M17.32 8.25h-4.433l1.643-5.04c.153-.624-.306-1.21-.879-1.21H8.15c-.459 0-.879.352-.917.82l-1.223 9.375c-.076.586.344 1.055.917 1.055h4.509l-1.758 7.617c-.114.586.306 1.133.88 1.133.343 0 .649-.156.801-.469l6.726-11.875c.382-.586-.077-1.406-.764-1.406"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "m11.165 9.5 2.038-6.25H8.436L7.295 12h5.711l-1.59 6.894 5.32-9.394h-5.571m3.365-6.29-1.643 5.04h4.433c.687 0 1.146.82.764 1.406l-6.725 11.875c-.153.313-.459.469-.803.469-.573 0-.993-.547-.879-1.133l1.758-7.617H6.926c-.573 0-.993-.469-.917-1.055L7.232 2.82c.038-.468.458-.82.917-.82h5.502c.573 0 1.032.586.88 1.21",
    clipRule: "evenodd"
  })));
};
export default SvgFeatureEasyApplyFilled;